/**
 * Dynamic URL path for the Shopify CDN
 */
import './sentry';
import './algolia';

/**
 * Although jQuery is imported via Webpack without an explicit import,
 * we still need to add it to the global window so other dependencies
 * that are not yet in the Webpack build can use utilize it.
 */
import $ from 'jquery';

import './theme/shopify-theme';
import './theme/pair-theme';

import './theme/templates/home';

import './theme/nav';

__webpack_public_path__ = window.assetsPath;
window.jQuery = $;
window.$ = $;
